export default __webpack_public_path__ + "710788d1e71ce53a4d4c28e05cf9f06a.svg";